export const begin = 1;
export const end = -1;
export const endAll = -1000;
export const pendingTask = 'pendingTask';
